import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@angular/cdk/platform';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoder, NativeGeocoderOptions, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
let k=1,j=90;
@Component({
  selector: 'app-create-cust-subscription',
  templateUrl: './create-cust-subscription.component.html',
  styleUrls: ['./create-cust-subscription.component.scss'],
})
export class CreateCustSubscriptionComponent {
  brand;
  apptTime;
  model;
  type;
  popLoad:boolean=false;
  size;
  time;
  cateName;
  cateId;
  category: any = [];
  slots;
  dateFormat;
  custItem;
  // minDate = new Date();
  categorysearchtypes:any= [];
  purchasedate:any;
  loader: boolean = true;
  active: boolean = true;
  editBool:boolean=false;
  vendordetails: boolean = false;
  item:any;
  fontStyle;
  typeObj;
  id;
  pic;
  cloneUsers:any=[];
  custName;
  itemCategoryObj;
  typeName;
  typeId;
  cost;
  payTotal;
  pageOne;
  pageTwo;
  users:any=[];Name;userId;orgId;
  discountCoupon;
  Oid;Id;
  assign:boolean;
  promotions;
  addItem:boolean=false;
  subsName;
  subsId;
  subsObj;
  totalSubsObj;
  typeObjAll;
  userMobile;
  contactNbrMob;
  custitem;
  custItemName;
  custItemId;
  custitemObj:any=[];
  custResItemObj:any=[];
  total;
  categoryId;
  startdate;
  enddate;
  fdateCheck;
  tdateCheck;
  subsItems;
  subscripId;
  fDate;
  tDate;
  totalItemType;
  autoGenerate:boolean = false;
  couponId;
  head:boolean=false;
  makeName;
  makeObj:any=[];
  makeId;
  modelObj:any = [];
  modelName;
  modelId;
  promoObj:any; 
  buttonObj:any=[{name:"Individual House",flat:false,id:1},
                 {name:"Flat",flat:true,id:2}]
  flatType = this.buttonObj[0].id;
  appt:boolean = this.buttonObj[0].flat;
  flatNo;
  clicked:boolean=false;
  flatName;
  doorNbr;
  street;
  identificationNo;
  colour;
  url;
  custReq:boolean=false;
addBtn:boolean=false;
serReq:boolean=false;
getSubsId;
optionId;
area;
capacity;
categoryCode;
carService:boolean=false;
  pricing:boolean=false;
  homeCleaning:boolean=false;
  typeCode;
  acService;
  timeVal:boolean=false;
  fridgeWashing;
  subType;
  subItemsType;
  optionName;
  timeChange:boolean = false;
  apptChange:boolean=false;

  constructor(private service: ApiService,public handler: HandlerService,public router: Router,public translate: TranslateService,
    public auth: AuthService,  public location: LocationService, private bottomSheet: MatBottomSheet,private platform:Platform,
    private loc: Geolocation,
    private geoCoder:NativeGeocoder) { }

  ionViewWillEnter() {
    this.getPackage(); 
    // this.blockDate()
    this.orgId=localStorage.getItem('organizationId')
    this.id = window.location.href.split('/').pop();
    this.dateFormat = this.auth.getDateformat();
    this.pageOne =true;
    this.pageTwo = false;
    this.popLoad = false;
    this.url=window.location.href     
      this.getCategory();
    this.getitemCategory();     
    this.getPromotions();
    this.itemSubType();
 
  }
  
  timeValueChange(){
    this.timeChange = true;
  }


  blockDate(){
    // Block From Date
    var someDate = new Date();
    var numberOfFromDaysToAdd = 0;
    someDate.setDate(someDate.getDate() + numberOfFromDaysToAdd); 
    var dd = someDate.getDate();
    var mm = someDate.getMonth() + 1;
    var month = mm-1;
    var y = someDate.getFullYear();
    this.fdateCheck = new Date(y, month, dd)
  }
  startDate(){
    this.enddate = "";
    this.fDate=this.returnDate(this.startdate);
    // var someDate1 = new Date(this.fDate);
    // var numberOfFromDaysToAdd = 1;
    // someDate1.setDate(someDate1.getDate() + numberOfFromDaysToAdd); 
    // var dd1 = someDate1.getDate();
    // var mm1 = someDate1.getMonth() + 1;
    // var month1 = mm1-1;
    // var y1 = someDate1.getFullYear();
    // this.tdateCheck = new Date(y1, month1, dd1);
  }

  endDate(){
    this.tDate=this.returnDate(this.enddate);
  }

  convertTimeChange(){
    this.apptChange = true;
  }
  
  returnDate(data) {
    let date = data.getDate();
    date = date < 10 ? '0' + date : date;
   let month = data.getMonth() + 1;
   month = month < 10 ? '0' + month : month;
   let year = data.getFullYear();
   return year + '-' + month + '-' + date;
 }


  getAppt(id){
    this.appt = id;
  }

  createCustItem() {
    if(this.custItemId){
      this.create();
    }
  else{
    this.loader = true;
    if(!this.makeName){
      this.makeName="XXX";
    }
    if(!this.modelName){
      this.modelName="XXX";
    }
    if(!this.colour){
      this.colour="XXX";
    }
    if(!this.identificationNo){
      this.identificationNo="TN00A0000"
    }
    var post={
      "make": this.makeName,
      "model": this.modelName,
      "type": this.typeId,   
      "custName":this.custName,
      "contactNbrMob":this.contactNbrMob,
      "itemCategoryId":this.categoryId,
      "userId":this.id,
      "identificationNo":this.identificationNo,
      "activeInd": true,
      "colour":this.colour, 
      "appt":this.appt,
      "houseNbr": this.location.houseNbr,
      "cityId": this.location.cityId,
      "stateId": this.location.stateId,
      "regionId":this.location.regionId,
      "zipcode":this.location.zipcode,
      "lat": this.location.lat,
      "lon": this.location.lon,
      "subItemTypeId":this.optionId,
      "capacity":this.capacity,
      "area":this.area,
    } 
    if(!this.appt){
      Object.assign(post,{"doorNbr":this.doorNbr,"street": this.location.street})
    }else{
      Object.assign(post,{"flatNo":this.flatNo, "flatName":this.flatName,})
    }
    this.service.custItem(post).subscribe(res=>{  
      this.custResItemObj = res; 
      this.custItemId=this.custResItemObj.id; 
      this. create();
      this.loader = false;   
   
    },
    err=>{
      this.loader=false;
      this.handler.err(err);
    })
  }
  
  }
  
 
    create() {
      this.loader = true;  
      if(!this.Id){
        this.payTotal=this.location.markedPrice;
      } 
      var post={
       "custItemId": this.custItemId,
       "providerServiceId":this.subsId,
       "cost" : this.location.markedPrice,
       "discountCoupon": this.Id,
       "payTotal": this.payTotal,
       "subscriptionInd":true,
       "activeInd": true,
       "categoryId": this.cateId, 
       "sendVendorContact" :this.vendordetails,   
       "custName"  :this.custName,
      "contactNbrMob" : this.contactNbrMob,
      "requestorId" : this.id,
      "orgId":localStorage.getItem('organizationId'),
      "status":1,
      "startDate":this.fDate,
      "endDate":this.tDate,
      "type":1,    
      "apptTime":this.convertTime(this.apptTime), 
        "houseNbr": this.location.houseNbr,
        "cityId": this.location.cityId,
        "stateId": this.location.stateId,
        "regionId":this.location.regionId,
        "zipcode":this.location.zipcode,
        "lat": this.location.lat,
        "lon": this.location.lon,   
        "appt":this.appt
      }
      if(!this.appt){
        Object.assign(post,{"doorNbr":this.doorNbr,"street": this.location.street})
      }else{
        Object.assign(post,{"flatNo":this.flatNo, "flatName":this.flatName,})
      }
      this.service.custItemSubscription(post).subscribe(res=>{
        this.handler.res("Subscription Created Successfully");
        this.loader = false;
         this.router.navigate(['/vendor-subs'])
   
      },
      err=>{
        this.loader=false;
        this.handler.err(err);
      })
    }

    convertTime(tim){
      var time;
      time = tim.split("T");
      time = time[1].split(".");
      time = time[0];
      return time
    }

    cancel(){
      this.router.navigate(['custItem/', + this.id])
    }
    editCustItem() {
    
      if(this.timeVal){
        this.subsItems.apptTime=this.convertTime(this.apptTime);
      }else{
        this.subsItems.apptTime = this.apptTime; 
      }   
      this.subsItems.custItemId=this.custItemId;
      this.subsItems.providerServiceId=this.subsId;
      this.subsItems.cost=this.location.markedPrice;
      this.subsItems.activeInd = true;
      this.subsItems.make = this.makeName;
      this.subsItems.model = this.modelName;
      this.subsItems.discountCoupon=this.Id;
      this.subsItems.payTotal=this.payTotal;
      this.subsItems.categoryId =  this.cateId; 
      this.subsItems.sendVendorContact = this.vendordetails;
      this.subsItems.custName = this.custName;
      this.subsItems.contactNbrMob =this.contactNbrMob;
      this.subsItems.custUserId=this.id;
      this.subsItems.houseNbr=this.location.houseNbr;
      this.subsItems.street=this.location.street;
      this.subsItems.cityId=this.location.cityId;
      this.subsItems.stateId=this.location.stateId;
      this.subsItems.regionId=this.location.regionId;
      this.subsItems.zipcode=this.location.zipcode; 
      this.subsItems.lat=this.location.lat;
      this.subsItems.lon=this.location.lon;
      this.subsItems.appt=this.appt;
      this.subsItems.doorNbr=this.doorNbr;
      this.subsItems.flatName=this.flatName;
      this.subsItems.flatNo=this.flatNo;
      this.subsItems.subscriptionInd=true;
     this.subsItems.startDate=this.fDate;
     this.subsItems.endDate=this.tDate; 
      this.subsItems.orgId=localStorage.getItem('organizationId');
      this.subsItems.status=1;
 

          
      this.service.updateCustItemSubs(this.subscripId,this.subsItems).subscribe(res=>{
        this.handler.res("Subscription Updated Successfully");
        this.loader = false;
        this.router.navigate(['custItem/', + this.id])
  
      },
      err=>{
        this.loader=false;
        this.handler.err(err);
  
      })
    }
  
    next(){
      this.pageOne = false;
      this.pageTwo = true;
      this.payTotal = this.location.markedPrice;
    }

    edit(){
      this.pageOne = false;
      this.pageTwo = true; 
    }

    returnDate1(data) {
      let date = data.getDate();
      date = date < 10 ? '0' + date : date;
      let month = data.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let year = data.getFullYear();
      return year + '-' + month + '-' + date;
    }

    popClose(){
      this.location.pop=false;
      this.location.newSearch="";
      this.location.dummy = false;
    }
  
    ionViewWillLeave(){
      this.custItemId = '';
      this.subsId= '';
      this.location.markedPrice= '';     
      this.location.subscriptionId = "";
      this.custItemId = "";
      this.location.pop = false;
      this.location.newSearch="";
      this.location.typeId ="";
      this.location.houseNbr="";
      this.location.cityId="";
      this.location.stateId="";
      this.location.street="";
      this.location.regionId="";
      this.location.zipcode="";
      this.location.lat="";
      this.location.lon="";     
      this.street="";
      this.doorNbr="";
      this.flatNo="";
      this.flatName="";
      this.Id= '';         
      this.cateId= '';  
      this.custName= '';    
      this.contactNbrMob='';
      this.userId='';
      this.cateName ='';
      this.typeName='';
      this.typeId="";
      this.custName="";  
      this.contactNbrMob='';
      this.custItemName='';  
      sessionStorage.removeItem('itemCategoryId')  
      sessionStorage.removeItem('custItemId')
    }

    clearTime() {
      this.time = 'Time';
      this.slots = [];
          }

  getCategory(){    
   this.service.getOrgCategory().subscribe((res: any) => {
   this.category=res; 
   this.getUsers(); 
   }) 
}           

    
  
  
  openBottomSheetCategoryType(){
   const dialogRef = this.bottomSheet.open(BottomSheet, {
   data: this.category,
   });
  dialogRef.afterDismissed().subscribe((res) => {
   if (res) {
   this.cateName = res.name;
    this.cateId = res.id; 
    this.categoryCode=res.code; 
    this.head=true;
    this.addBtn=true;
    if(this.url.includes('cust-item-subs')){
      this.custitem=this.custitemObj.filter(res =>res.itemCategoryId == this.cateId && res.make != "XXX");   
      this.custitem.every(res=>Object.assign(res,{clicked:false})); 
      this.head=true;  
      this.addBtn=true;  
      
    } 

    if(this.categoryCode=="CAR"){
      this.carService=true;
    }else{
      this.carService=false;
    }
    if(this.categoryCode =="PSC" || this.categoryCode =="HC" ){              
      this.pricing=true;
      this.homeCleaning=true;
      
    } else{
      this.pricing=false;
      this.homeCleaning=false;
    }   
  } 
  if(this.categoryCode =="CAR"){
    this.getCustMake();
  }
 
    });
  }

  getUsers(){
    this.loader=true;
    this.service.getUserById(this.id).subscribe((res:any) => {
      this.users = res;
      // this.users = this.users.filter(res =>{return res.userId == this.userId})
      this.custitemObj=this.users.custItems;  
      this.custName = res.firstName;
      this.contactNbrMob = this.users.contactNbrMob;
      if(this.users.addresses[0]  && !this.url.includes('edit-cust-item-subs')){
        this.location.regionId=this.users.addresses[0].regionId;
        this.location.street=this.users.addresses[0].street;
        this.location.stateId=this.users.addresses[0].stateId;
        this.location.cityId=this.users.addresses[0].cityId;
        this.location.zipcode=this.users.addresses[0].zipcode;
        this.appt=this.users.addresses[0].appt;
        if(!this.appt){
          this.flatType = 1;
        }else{
          this.flatType = 2;
        }
        this.doorNbr=this.users.addresses[0].doorNbr;
        this.flatName=this.users.addresses[0].flatName;
        this.flatNo=this.users.addresses[0].flatNo;
        this.loader=false;
      }
      
      
      if(this.url.includes("cust-subs-booking")){                
        this.custItemId=sessionStorage.getItem('custItemId');
        this.custitem = this.users.custItems.filter(res=>{ return res.id == this.custItemId && res.make != "XXX"})   
        this.custitem.every(res=>Object.assign(res,{clicked:true})); 
        this.custReq=true;
        this.head = true 
        this.addBtn = false ;  
        this.location.regionId= this.custitem[0].regionId;
        this.location.street= this.custitem[0].street;
        this.location.stateId= this.custitem[0].stateId;
        this.location.cityId= this.custitem[0].cityId;
        this.location.zipcode= this.custitem[0].zipcode;
        this.appt= this.custitem[0].appt;
        if(!this.appt){
          this.flatType = 1;
        }else{
          this.flatType = 2;
        }
        this.doorNbr= this.custitem[0].doorNbr;
        this.flatName= this.custitem[0].flatName;
        this.flatNo= this.custitem[0].flatNo;
        this.location.typeId = this.custitem[0].type;
        setTimeout(() => {
          this.loader=false; 
        }, 2000);

      }   
      if(this.url.includes('cust-item-subs')){        
        this.custitemObj=this.users.custItems;    
        setTimeout(() => {
          this.loader=false; 
        }, 2000);
      }
      if(this.url.includes('edit-cust-item-subs')){
        this.editBool=true;
        this.getSubsId=sessionStorage.getItem('SubsId');  
        this.service.getCustItemSubsById(this.getSubsId).subscribe((res:any)=>{     
            this.subsItems = res;   
            this.location.markedPrice=this.subsItems.cost;  
            this.location.typeId=this.subsItems.type;       
            this.Id=this.subsItems.discountCoupon;
            this.subscripId=this.subsItems.id;
            this.makeName = this.subsItems.make;
            this.modelName = this.subsItems.model;    
            this.vendordetails=this.subsItems.sendVendorContact;    
            this.payTotal= this.subsItems.payTotal;         
            this.startdate=this.subsItems.startDate;
            this.enddate=this.subsItems.endDate;
            if(this.startDate){
              var x = this.startdate.split("T");
              this.fDate = x[0];
            }
            if(this.enddate){
              var y = this.enddate.split("T");
              this.tDate = y[0];
            }
            if(!this.subsItems.apptTime){
              this.timeVal = true;
            }
            this.apptTime = this.subsItems.apptTime;    
            this.addBtn=false;
            this.head=true;
            this.custReq=true;
            this.custItemId=this.subsItems.custItems[0].id;
            this.custitem = this.users.custItems.filter(res=>{ return res.id == this.custItemId})      
            this.custitem.every(res=>Object.assign(res,{clicked:true})); 
            this.appt = this.subsItems.appt
            if(!this.appt){
              this.flatType = 1;
            }else{
              this.flatType = 2;
            }
            this.doorNbr=this.subsItems.doorNbr;
            this.flatName=this.subsItems.flatName;
            this.flatNo=this.subsItems.flatNo;
            this.location.houseNbr=this.subsItems.houseNbr;
            this.location.street=this.subsItems.street;
            this.location.cityId=this.subsItems.cityId;
            this.location.stateId=this.subsItems.stateId;
            this.location.regionId=this.subsItems.regionId;
            this.location.zipcode =this.subsItems.zipcode;         
            var x = this.subsItems.startDate.split('T');
            var y = this.subsItems.endDate.split('T');
           
            setTimeout(() => {
              if (this.category.length > 0) {
                this.category.map(res1 => {
                  if (res1.id == this.subsItems.categoryId) {
                    this.cateName = res1.name;
                    this.cateId = res1.id;
                  }
                })
              } 
            }, 500);
            setTimeout(() => {
              if (this.totalItemType.length > 0) {
                this.totalItemType.map(res1 => {
                  if (res1.id == this.subsItems.itemCategoryId) {
                    this.typeName = res1.name;
                    this.typeId = res1.id;
                  }
                })
              } 
            }, 500);       
              if (this.subsObj.length > 0) {
                this.subsObj.map(res1 => {
                  if (res1.id == this.subsItems.providerServiceId) {
                    this.subsName = res1.name;
                    this.subsId = res1.id;
                  }
                })
              } 
       
          setTimeout(() => {
            this.loader = false;
          }, 2000);
                
        },err=>{
          this.loader = false;
          this.handler.err(err);
        }) 
       
      }
      
       },err=>{
        this.handler.err(err)
        this.loader = false;
      })
  }

  openBottomSheetSubs(){
    if(this.custItemId){
      this.subsObj = this.totalSubsObj.filter(res=> res.itemCategoryId == this.cateId );
      const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.subsObj,
      });
     dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
      this.subsName = res.name;
       this.subsId = res.id;
       this.couponId = res.discAdId;
       this.location.subscriptionId = res.id;
       if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined && 
         this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
           var data={
             "itemTypeId": this.location.typeId,
             "region": this.location.regionId,
             "serviceId":this.location.subscriptionId 
           }
           this.service.getCost(data).subscribe((res:any)=>{
             if(res!=null){
               this.location.markedPrice = res[0].cost;
             }else{
               this.handler.error("Please Select Different Location");
               this.location.markedPrice = "";
             }
           }, err => {
             this.handler.err("");

           })       
        }
       }
       });
    }else{
      this.handler.error("Please Select Customer Item");
    }
   
    }

    
  openBottomSheetSubs1(){ 
    if(this.typeId)  { 
      this.subsObj = this.totalSubsObj.filter(res=> res.itemCategoryId == this.cateId );
      const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.subsObj,
      });
     dialogRef.afterDismissed().subscribe((res) => {
      if (res) {
      this.subsName = res.name;
       this.subsId = res.id;
       this.couponId = res.discAdId;
       this.location.subscriptionId = res.id;
       if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined && 
         this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
           var data={
             "itemTypeId": this.location.typeId,
             "region": this.location.regionId,
             "serviceId":this.location.subscriptionId 
           }
           this.service.getCost(data).subscribe((res:any)=>{
             if(res!=null){
               this.location.markedPrice = res[0].cost;
             }else{
               this.handler.error("Please Select Different Location");
               this.location.markedPrice = "";
             }
           }, err => {
             this.handler.err("");

           })       
        }
       }
       });    
      }else{
        this.handler.error("Please Add Your Item");
      }
    }

    openBottomSheetItemType(){
      this.itemCategoryObj = this.totalItemType.filter(res=> this.cateId == res.itemCategory )
        const dialogRef = this.bottomSheet.open(BottomSheet,{
          data: this.itemCategoryObj,
        });
        dialogRef.afterDismissed().subscribe((res:any) => {
          if(res){
            this.typeName = res.name;
            this.typeId=res.id;
            this.location.typeId=res.id;
            this.typeCode= res.code;
            if(this.typeCode=="AC"){
              this.fridgeWashing=true;
              this.acService=true;
            }   
            if(this.typeCode=="RF" || this.typeCode=="WM"){
              this.fridgeWashing=true;
            } 
            if(this.location.typeId != undefined && this.location.regionId != undefined &&this.location.subscriptionId != undefined &&
              this.location.typeId != "" && this.location.regionId != "" &&this.location.subscriptionId != ""){
                var data={
                  "itemTypeId": this.location.typeId,
                  "region": this.location.regionId,
                  "serviceId":this.location.subscriptionId 
                }
                this.service.getCost(data).subscribe((res:any)=>{
                  if(res!=null){
                    this.location.markedPrice = res[0].cost;
                  }else{
                    this.handler.error("Please Select Different Location");
                    this.location.markedPrice = "";
                  }
                }, err => {
                  this.handler.err(err);
                })
            }
          }
           });
   
  }  

  // getUser(val) { 
  //   let x = val.length;
  //   if(x > 0){
  //     this.service.searchCustomers("CUST",val,this.Oid).subscribe((res: any) => {
  //       this.cloneUsers =JSON.parse(JSON.stringify(res)); 
  //     })
  //   }
  //   }

    
    onInput() {
      this.location.autoComplete();
    }

  
    

    getPackage(){
      this.service.getAllSubscriptions().subscribe((res:any)=>{
      this.subsObj = res;  
      this.subsObj = this.subsObj.filter(res =>{return res.packageInd == true})
      this.totalSubsObj=this.subsObj;   
     },err =>{
       this.handler.err(err)     
     })
       }

    getitemCategory(){
      this.service.getItemType().subscribe(res=>{
        this.totalItemType = res;
        console.log(this.totalItemType)
        })
    }

 
  getPromotions(){
    this.service.getServiceCoupon(this.orgId).subscribe(res=>{
      this.promotions = res;
    })
  }
     
       
  openBottomSheetDiscount(): void {
    this.promoObj = this.promotions.filter(res=>{ return res.id == this.couponId});
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.promoObj,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.discountCoupon = res.name;
      this.Id=res.id;
      this.getpayTotal();
    });
  }

      getpayTotal(){
        this.loader = true;
        var post={
          "cost":this.location.markedPrice,
          "discountCoupon":this.Id
        }
        this.service.getPayTotal(post).subscribe((res:any)=>{
          if(res){      
         this.payTotal = res.payTotal;
         this.loader = false;
          }
        })
      }



  sendId(data,id){
    data.clicked = ! data.clicked;
    this.custitem.map(res=>{if(id!=res.id){
      res.clicked=false;   
    }
    })
    this.custItemId = id;
    let x=this.custitem.find(res=>res.clicked);
    if(!x){
      this.subsName="";
      this.subsId="";
      this.custItemId ="";
    }
    this.location.typeId = data.type;
    this.location.houseNbr=data.houseNbr;
    this.location.cityId=data.cityId;
    this.location.stateId=data.stateId;
    this.location.street=data.street;
    this.location.regionId=data.regionId;
    this.location.zipcode=data.zipcode;
    this.location.lat=data.lat;
    this.location.lon=data.lon;
    this.appt=data.appt;
    if(!data.appt){
      this.flatType = 1;
    }else{
      this.flatType = 2;
    }
    this.street=data.street;
    this.doorNbr=data.doorNbr;
    this.flatNo=data.flatNo;
    this.flatName=data.flatName;
    this.custReq=true;
    this.serReq=false;
  }


 

  addCustItem(){
    if(this.custitem.length>0){
    this.custitem.map(res=>{
      if(res.clicked){
        res.clicked=false
       }
      })
    }
    this.addItem = true;
    this.custReq=false;
    this.serReq=true;
    this.custItemId = "";
    this.location.regionId=this.users.addresses[0].regionId;
    this.location.street=this.users.addresses[0].street;
    this.location.stateId=this.users.addresses[0].stateId;
    this.location.cityId=this.users.addresses[0].cityId;
    this.location.zipcode=this.users.addresses[0].zipcode;
    this.appt=this.users.addresses[0].appt;
    this.doorNbr=this.users.addresses[0].doorNbr;
    this.flatName=this.users.addresses[0].flatName;
    this.flatNo=this.users.addresses[0].flatNo;
  }
  openBottomSheetsubType(): void{ 
    this.subItemsType=this.subType.filter(res=> res.itemTypeId==this.typeId)
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data:this.subItemsType,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      this.optionName = res.name;
      this.optionId = res.id; 
      });
   }
  itemSubType(){
    this.service.getSubItemType().subscribe(res=>{
      this.subType=res;
     
    })
  }

  openLocation(){
    this.location.lat="";
    this.location.lon="";
     this.location.zipcode="";
     this.location.street="";
     this.location.stateId="";
     this.location.cityId="";
     this.location.regionId="";
    this.setLoc();  
    this.location.pop = false;
  }
  
  setLoc(){
    if(this.platform.ANDROID || this.platform.IOS){
        let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
      this.loc.getCurrentPosition().then(res => {
        this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
            let x: any = result;
            localStorage.setItem('location', JSON.stringify(x));
            let loc;
            loc=JSON.parse(localStorage.getItem('location'));
            this.location.lat=loc[0].latitude;
            this.location.lon=loc[0].longitude;
             this.location.zipcode=loc[0].postalCode;
             this.location.street=loc[0].thoroughfare;
             this.location.stateId=loc[0].administrativeArea;
             this.location.cityId=loc[0].locality;    
             this.location.regionId=loc[0].subLocality;       
        })        
    })
 }   
}
getCustMake(){
  this.modelName = "" ;
  this.modelId="";
  this.service.getMake(this.cateId).subscribe((res:any)=>{
    if(res){
      this.makeObj = res;
      console.log(this.makeObj)
    }
  },err=>{
    this.handler.err(err)
  })
}

getCustModel(){
  this.popLoad=true;
  this.service.getModel(this.cateId,this.makeId).subscribe((res:any)=>{
  this.modelObj = res;    
  this.popLoad=false;
  },
  err=>{
       this.handler.err(err);

  })
}
openBottomSheetMake(): void {    
  const dialogRef = this.bottomSheet.open(BottomSheet,{
    data: this.makeObj,
  });
  dialogRef.afterDismissed().subscribe((res:any) => {
    if(res){
      this.makeName = res.name;
      console.log(this.makeName)
      this.makeId=res.id; 
      if(this.makeId){
        this.getCustModel();
      }  
      }        
  });
}
openBottomSheetModel(): void {    
  const dialogRef = this.bottomSheet.open(BottomSheet,{
    data: this.modelObj,
  });
  dialogRef.afterDismissed().subscribe((res:any) => {
    if(res){
      this.modelName = res.name;
      this.modelId=res.id;     
      }        
  });
}
  
}
